import { StyleSheet, css } from 'aphrodite/no-important';

const Years = ({scaleFactor, firstYear, lastYear}) => {
  const duration = lastYear - firstYear;
  const firstCentury = Math.floor(firstYear / 100) * 100;
  const groups = duration / 100;
  const yearGroups = [];

  let n = 0;
  while(n <= groups + 1){
    const groupStartYear = firstCentury + (100 * n);
    yearGroups.push(groupStartYear);
    n++;
  }

  return (
    <div className={css(styles.yearGroups)}>{
      yearGroups.map((year)=>(
        <div key={year} className={css(styles.year)} style={{minWidth: `${scaleFactor * 100}px`}}>{year}</div>
      ))
    }
  </div>
  )
}

const styles = StyleSheet.create({
  yearGroups: {
    display: "flex",
  },
  year: {
    minHeight: 'calc(100vh - 25px)',
    boxSizing: 'border-box',
    padding: '3px 5px',
    color: '#999',
    borderRight: '1px solid #EEE',
  },
});

export default Years;
